<template>
<!-- FINAL ICARE -->
  <form @submit.prevent>
     <CModal
        :title.sync="title" 
        color="info"
        :closeOnBackdrop ="false"
        :show.sync="show">
        <CRow>
          <CCol>
             <label > Choose Couple </label>
            <b-form-select v-model="form.spouse_id" :options="options"></b-form-select>
            
          </CCol> 
          </CRow>
       
        <template #footer>
        <CButton @click="show = false" color="danger">Cancel</CButton>
        <CButton  v-if="mode === 'edit'" type="submit" v-on:click.prevent="assign_couple(form.uuid, form.spouse_id)"  variant="outline" color="info">Update</CButton>
     
        </template>
    </CModal>
  </form>
</template>

<script>
import EventBus from '@/eventBus';

import member from '@/services/member';
import satelite from '@/services/satelitechurch'
import icare from '@/services/icare'

import moment from 'moment';

export default {
name: 'couplemodal',
  data () {
    return {
    show: false,
    title: 'Default Title',
    mode: '',
    form:{
      uuid:'',
      fullname:'',
      spouse_id:'',
    },
    options:[],
   
    }
  },
  
  mounted (){
     

     
   },
   
  created () {
    var self = this; 
    EventBus.$on('OPEN_MODAL_COUPLE', (params) => {
      if(params.data){
        member.getMemberbyID(params.data)
        .then(res => {
          self.show = true; 
          self.title = params.title;
          self.mode = params.mode;
          self.form.uuid = res.data.uuid;
          self.form.fullname = res.data.fullname;
          
        }).catch ((err) => {
          var params = {title: 'Error', mode:'danger', data:err.response.data.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        })

        this.options = []
        member.getCouple(params.data)
        .then(res => {
          for (let i=0; i <= res.data.length-1; i++){
            this.options.push({text: res.data[i].fullname, value:res.data[i].uuid})
          }
        }).catch((er) =>{
          var params = {title: 'Error', mode:'danger', data:err.response.data.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        })

      }else{
        self.show = true;
        self.title = params.title;
        self.mode = params.mode;
        self.form.uuid = "";
        self.form.name = "";
      }
    });

  },
  methods: {
    open () {
      this.show = true;
    },
    close () {
      this.show = false;
    },
  
    assign_couple(id,spouse_id){
        this.show = false;
        if(confirm("Do you really want to assign as couple?")){
          var param = {
            spouse_id: spouse_id,
          }
          member.assign_couple(id, param)
          .then(res => {
            //this.load()
            EventBus.$emit('PAGE_UPDATE', true)
            var params = {title: 'Success', mode:'success', data:res.message}
            EventBus.$emit('OPEN_MODAL_ALERT', params)
          }).catch ((err) => {
            var params = {title: 'Error', mode:'danger', data:err.response.data.message}
            EventBus.$emit('OPEN_MODAL_ALERT', params)
          })
        }
      },
   
     
   
  }
}
</script>

<style>

</style>